<template>
  <div id="externalEmailChanged">
    
    <div class="vo-external-card">
      <vo-external-header :title="title"></vo-external-header>

      <div class="vo-body">
        
        <div class="vo-title">{{ title }}</div>
        
        <div class="vo-context">Please wait while we verify your email address.</div>
        
        <div class="text-center">
          <v-progress-circular v-if="lockout" style="margin: 8px auto; width: 40px;" indeterminate color="primary" :size="40"></v-progress-circular>
        </div>

      </div>

    </div>
  </div>
</template>


<script>

  export default {
    data () {
      return {
        verification: false,
        title: 'Email Changed',
        lockout: false
      }
    },

    methods: {
      
      // verifyEmail() - Verifies token is valid, then changes the email
      verifyEmail () {
        if (this.lockout) return;
        this.lockout = true;

        this.$store.dispatch('verifyEmailToken', {
          token: this.verification.token
        })
        .then(data => {
          
          this.lockout = false;

          Dialog.showDialog({
            title: 'Email Changed',
            body: 'Your email has been changed. You will now be redirected to the login page.',
            confirm: {
              title: 'Got It',
              action () {
                console.log('WINDOW.APP_URL', window.APP_URL);
                window.open(APP_URL, '_self');
                return Promise.resolve();
              }
            },
            modal: true
          });

        })
        .catch(e => {
          this.lockout = false;
          console.log('Error:', e);
          Toast.showError(e);
        });

      },

      //fetchVerificationToken(token) - Fetch verification from server and call appropriate function
      fetchVerificationToken (token) {

        this.$store.dispatch('loadVerificationToken', {
          token: token
        })
        .then(data => {
          this.handleVerificationToken(data);
        })
        .catch(e => {
          this.handleInvalidToken();
        });
        
      },

      // handleVerificationToken(verification) - Validate verification, allow user to continue if valid 
      handleVerificationToken (verification) {
        
        // Incorrect verification type
        if (verification.type !== 'change email') {
          this.handleInvalidToken();
        }

        // Already verified
        if (verification.status === 'verified') {

          Dialog.showDialog({
            title: 'Email Address Verified',
            body: 'Your new email address has already been verified. You will now be redirected to the login page where you may sign in using your new email address.',
            confirm: {
              title: 'Got It',
              action () {
                console.log('WINDOW.APP_URL', window.APP_URL);
                window.open(APP_URL, '_self');
                return Promise.resolve();
              }
            },
            modal: true
          });
        }

        // Expired
        else if (verification.status === 'expired') {
          
          Dialog.showDialog({
            title: 'Token Expired',
            body: 'Your email change token has expired. You will now be redirected to the login page. If you still need to change your email address, you can create a new request by signing into Vilio with your old email address and creating a new request on the Settings page.',
            confirm: {
              title: 'Got It',
              action () {
                console.log('WINDOW.APP_URL', window.APP_URL);
                window.open(APP_URL, '_self');
                return Promise.resolve();
              }
            },
            modal: true
          });
        }

        // Expected status
        else if (verification.status === 'sent') {
          this.verification = verification;
          this.verifyEmail();
        }

        // Other unexpected state
        else {
          this.handleInvalidToken();
        }
      },

      handleInvalidToken () {
        Dialog.showDialog({
          title: 'Token Invalid',
          body: 'Your email change token is invalid. You will now be redirected to the login page. If you still need to change your email address, you can create a new request by signing into Vilio with your old email address and creating a new request on the Settings page.',
          confirm: {
            title: 'Got It',
            action () {
              console.log('WINDOW.APP_URL', window.APP_URL);
              window.open(APP_URL, '_self');
              return Promise.resolve();
            }
          },
          modal: true
        });
      }

    },

    mounted () {
    
      // Make sure user has a token
      if (!this.$route.query || this.$route.query && !this.$route.query.token) this.handleInvalidToken();
      else this.fetchVerificationToken(this.$route.query.token);
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #externalEmailChanged {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    @include scrollable;

    .text-center {
      text-align: center;
    }
  }

  @media screen and (max-width: 780px) {
   
    #externalEmailChanged {
      
      background: $lightGreen !important;

      .vo-title {
        display: none;
      }
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/ExternalChangeEmail.vue